<template>
  <transition name="slide-fade">
    <v-system-bar app dark color="error" v-if="offline">
      <span class="message">
        <v-btn small icon text>
          <v-icon>mdi-wifi-off</v-icon>
        </v-btn>
        You don't have an internet connection
      </span>
    </v-system-bar>
  </transition>
</template>

<script>

  export default {
    name: 'SystemBar',
  }
</script>

<style scoped>
  @keyframes slideX {
    0% {
      transform: translateX(100vw);
    }
    100% {
      transform: translateX(-100vw);
    }
  }
  .message {
    animation: slideX 15s linear 20s infinite;
  }
</style>
